import { render, staticRenderFns } from "./entrega.vue?vue&type=template&id=b6792d0a"
import script from "./entrega.vue?vue&type=script&lang=js"
export * from "./entrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports